import {
  Box,
  Dialog as MuiDialog,
  DialogContent,
  Divider,
  IconButton,
  SvgIcon,
} from '@mui/material';
import type { DialogProps as MuiDialogProps, Breakpoint } from '@mui/material';
import type { ReactNode } from 'react';
import { Typography } from './Typography';

export interface DialogProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  maxWidth?: Breakpoint | false;
  fullWidth?: boolean;
  PaperProps?: MuiDialogProps['PaperProps'];
}

export const Dialog = ({
  open,
  title,
  onClose,
  children,
  footer,
  maxWidth = 'sm',
  fullWidth = true,
  PaperProps,
}: DialogProps) => (
  <MuiDialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth={fullWidth} PaperProps={PaperProps}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 3,
        py: 2,
        flexShrink: 0,
      }}
    >
      <Typography
        variant="h6"
        display="block"
        noWrap
        sx={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', flex: 1, mr: 2 }}
      >
        {title}
      </Typography>
      <IconButton aria-label="close" onClick={onClose}>
        <SvgIcon viewBox="0 0 24 24">
          <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" />
        </SvgIcon>
      </IconButton>
    </Box>
    <Divider />
    <DialogContent>
      <Box sx={{ pt: 1 }}>{children}</Box>
    </DialogContent>
    {footer && (
      <Box sx={{ px: 3, pb: 3, pt: 2, flexShrink: 0 }}>
        {footer}
      </Box>
    )}
  </MuiDialog>
);
